import { render, staticRenderFns } from "./save.vue?vue&type=template&id=a017421c"
import script from "./save.vue?vue&type=script&lang=js"
export * from "./save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports